import { useEffect } from "react";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";
import { uggGAEvent } from "@ugitgud/legos/components/util/UggGAEventProvider";

export const CLASSIC_BANNER_CTA = "classic-banner-cta";

interface ClassicBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

const ZILEAN_IMG_STYLE: React.CSSProperties = { width: "1440px", objectFit: "none", objectPosition: "left center" };

export function ClassicBanner(props: ClassicBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  useEffect(() => {
    uggGAEvent("classic-banner-cta-view", utmSource || "unknown");
  }, []);

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  const zileanUrl = "https://static.bigbrain.gg/assets/ugg/cta/classic-zilean.png";

  return (
    <div className={classNames("w-full h-[48px] relative overflow-hidden bg-[#060B20] border-b border-b-[#C8B24F]", className)}>
      <img
        src={zileanUrl}
        alt=""
        className="xs:hidden absolute top-0 h-[48px] max-w-none z-0 right-[-830px]"
        style={ZILEAN_IMG_STYLE}
      />

      <div
        className="absolute inset-y-0 left-0 w-[120px] z-[5] pointer-events-none"
        style={{ background: "linear-gradient(90deg, rgba(6, 11, 32, 0.75) 0%, rgba(6, 11, 32, 0) 100%)" }}
      />
      <div
        className="absolute inset-y-0 right-0 w-[120px] z-[5] pointer-events-none"
        style={{ background: "linear-gradient(270deg, rgba(6, 11, 32, 0.75) 0%, rgba(6, 11, 32, 0) 100%)" }}
      />

      <div className={classNames("absolute inset-0 flex items-center justify-start xs:justify-center", { "pr-10": onClose })}>
        <div className="relative flex items-center gap-[12px] xs:gap-[16px] sm:gap-[24px] pl-3 pr-3 md:pl-6 md:pr-4 text-white">
          <img
            src={zileanUrl}
            alt=""
            className="hidden xs:block absolute top-0 h-[48px] max-w-none z-0 left-[-600px] sm:left-[-695px]"
            style={ZILEAN_IMG_STYLE}
          />

          <img
            src="https://static.bigbrain.gg/assets/lol/icons/classic-logo.png"
            alt="League Classic"
            className="relative z-10 hidden xs:block h-[45px] w-[104px] shrink-0 object-contain"
          />

          <div className="relative z-10 flex flex-col justify-center shrink-0">
            <span className="font-['Barlow_Condensed'] font-bold text-[18px] uppercase leading-none tracking-wide whitespace-nowrap text-white">
              TAKE A TRIP TO THE PAST WITH U.GG
            </span>
            <span className="text-[12px] text-white leading-none mt-[3px] whitespace-nowrap">
              We have you covered for all things Classic.
            </span>
          </div>

          <div
            className="relative z-10 flex items-center justify-center shrink-0 h-[30px] w-[87px] ml-[8px] bg-accent-blue-600 border border-accent-blue-400 rounded-[3px] cursor-pointer"
            onClick={onUrlClick}
          >
            <span className="font-['Barlow_Condensed'] font-semibold text-white text-[13px] whitespace-nowrap">CHECK IT OUT</span>
          </div>
        </div>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]" />
        </div>
      )}
    </div>
  );
}
